import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {GlobalService} from 'app/global/global.service';
import {RouterService} from 'app/global/router.service';
import {contentBlock} from 'app/interfaces/contentBlock';
import uuid from 'short-unique-id';
import {IExtraFiledFormInterface} from '../../../../global/extra-filed-form.interface';
import {DocumentsService} from '../../documents/documents.service';
import {Recipient, RecipientRole} from '../../edit-template/edit-template.dto';
import {EditTemplateService} from '../../edit-template/edit-template.service';
import {HelperService} from '../../edit-template/helper.service';
import {EditorEmitterService} from '../../events/editor-emitter.service';
import {RecipientfieldsService} from '../../settings/recipientfields/recipientfields.service';
import {TemplateService} from '../../templates/templates.service';
import { CreatedVia } from './add-new.dto';
import { DocumentTypeEnum } from '../../templates/template.dto';

@Component({
  selector: 'app-add-new',
  templateUrl: './add-new.component.html',
  styleUrl: './add-new.component.scss'
})
export class AddNewComponent implements OnInit {
  @Input() title: string;
  @Input() label: string;
  @Input() addViaRecipient: boolean;
  @Input() recipient: Recipient;
  @Input() createdVia: CreatedVia;
  public add_new_form: FormGroup;
  public submitted = false;
  public loader: boolean = false;
  public uuid = new uuid({ length: 6, dictionary: 'number' });
  public blocks: Partial<IExtraFiledFormInterface> = {};
  constructor(
    private router: Router,
    private templateService: TemplateService,
    private globalService: GlobalService,
    private recipientfieldsService: RecipientfieldsService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private documentsService: DocumentsService,
    private editorEmitterService: EditorEmitterService,
    private editTemplateService: EditTemplateService,
    private _routerService: RouterService,
    private _helperService:HelperService
  ) { }

  ngOnInit() {
    this.initAddNewForm(true);
    if(this.addViaRecipient){
      const role = this._helperService.addNewRole('document_id', null, 1, false, this.recipient);
      this.initAddNewForm(true, {}, [role]);
    }else{
      this.recipientfieldsService.fetchRecipientFields().subscribe({
        next : (roles:RecipientRole[]) => {
          const template_roles = roles || [];
          this.initAddNewForm(true, {}, template_roles);
        },
        error : (err) => {
          this.globalService.toastrError(err);
          this.loader = false;
          return;
        }
      });
    }
  }



  initAddNewForm(isNewDocument: boolean = false, formData: { name?: string, content?: string, blocks?: { [key: string]: string } } = {}, template_roles:RecipientRole[] = []){
    const contentUuid = this.uuid();
    this.add_new_form = this.fb.group({
      template: this.fb.group({
        name: [formData?.name ?? '', Validators.required],
        template_id: [null],
        content: [isNewDocument ? this.globalService.defaultEditor({uuid: contentUuid}) : formData?.content],
      }),
      template_details: this.fb.group({
        visible_name: [''],
        save_to_folder: [0],
        folders_id: [null],
        attach_video: [0],
        video_type: ['youtube'],
        video_url: [''],
        video_title: [''],
        type: [(this.createdVia === CreatedVia.DOCUMENT) ? DocumentTypeEnum.TEMPLATEDOCUMENT : DocumentTypeEnum.REGULAR]
      }),
      signature: this.fb.group({
        language: ['english'],
        signing_deadline: [''],
        signing_reminder: [''],
        recurring: [0],
        invitation_message: [''],
        confirmation_message: [''],
        document_key: [0],
        dk_type: ['password'],
        dk_password: [''],
        dk_password_hint: [''],
        dk_send_via_sms: [0],
        chat: [0],
      }),
      top_section: this.fb.group({
        document_type_id: [null],
      }),
      template_roles: this.fb.array(this._helperService.getRoles(template_roles))
    });
    if(isNewDocument){
      const block = {};
      block[contentUuid] = contentBlock.block({ uuid: contentUuid });
      this.blocks['blocks'] = block;
    }else {
      this.blocks['blocks'] = formData?.blocks;
    }
  }




  addNew() {
    this.submitted = true;
    if (this.add_new_form.invalid) {
      return;
    }
    this.submitted = false;
    this.loader = true;
    this.editorEmitterService.setUnsavedChangesFlag(false);
    this.add_new_form.value['fields_data'] = this.blocks;
    this.documentsService.createDocument(this.add_new_form.value).subscribe({
      next:(document) => {
        this.loader = false;
        this.activeModal.close();
        //@todo : routeReuseStrategy should be removed from here and should be handled in the router service
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this._routerService.redirectCrmUserToRoute(`/send-document/${document.template.id}`);
    },
    error: () => {
      this.loader = false;
    }});
  }
}
